// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const LINK = (fg) => `flex:none;padding:0;border:none;background:none;font-family:inherit;font-size:11.5px;color:${fg};cursor:pointer;text-decoration:underline;text-underline-offset:2px`;
const SMALL = 'flex:none;height:26px;padding:0 10px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;font-family:inherit;font-size:11.5px;color:var(--ink-2);cursor:pointer';

function Card({ edge, focused, children }) {
  return (
    <div style={sx(`display:flex;flex-direction:column;gap:3px;padding:9px 10px 9px 12px;border:1px solid ${focused ? '#0052CD' : '#DCE4F2'};border-left:3px solid ${edge};border-radius:8px;background:#fff`)}>
      {children}
    </div>
  );
}

function FlagCard({ f }) {
  return (
    <Card edge={f.accepted ? '#0F7A55' : '#D92D20'} focused={f.focused}>
      <span style={sx(`font-size:10.5px;color:var(--ink-4)`)}>{f.scope}</span>
      <span style={sx(`font-size:12px;font-weight:500;color:var(--ink)`)}>{f.where}</span>
      <span style={sx(`font-size:11.5px;color:var(--ink-2);line-height:1.4`)}>{f.what}</span>
      <span style={sx(`display:flex;align-items:center;gap:8px;font-size:11px;color:${f.accepted ? '#0F7A55' : '#B42318'}`)}>
        {f.status}
        <button type="button" onClick={f.onGo} style={sx(LINK('#0052CD'))}>Go to cell</button>
        {f.onAccept ? (
          <button type="button" data-testid="cohort-flag-accept" onClick={() => f.onAccept()} style={sx(`${SMALL};height:24px;margin-left:auto;border:none;background:#0052CD;color:#fff`)}>Accept</button>
        ) : null}
      </span>
    </Card>
  );
}

export default function CohortFlagsPanel({ p }: { p: any }) {
  if (!p) return null;
  const flags = p.tab === 'flags';
  return (
    <aside aria-label="Flags and overrides" data-testid="cohort-flags-panel" style={sx(`flex:none;width:320px;display:flex;flex-direction:column;min-height:0;border-left:1px solid #DCE4F2;background:#F7FAFD`)}>
      <div style={sx(`flex:none;display:flex;align-items:center;gap:8px;padding:10px 12px 8px`)}>
        <label style={sx(`flex:1;min-width:0;display:flex;align-items:center;gap:6px;font-size:12px;color:var(--ink-2);cursor:pointer`)}>
          <input type="checkbox" checked={!!p.only} onChange={p.onOnly} />
          {p.onlyLabel}
        </label>
        <button type="button" aria-label="Close" onClick={p.onClose} style={sx(`flex:none;width:24px;height:24px;border:none;border-radius:6px;background:none;font-family:inherit;font-size:15px;line-height:1;color:var(--ink-3);cursor:pointer`)}>×</button>
      </div>
      <div style={sx(`flex:1;min-height:0;overflow:auto;display:flex;flex-direction:column;gap:8px;padding:0 12px 12px`)}>
        {flags ? (
          p.flags.length ? p.flags.map(f => <FlagCard key={f.key} f={f} />) : <p style={sx(`margin:4px 0;font-size:12px;color:var(--ink-3)`)}>{p.flagsEmpty}</p>
        ) : (
          p.overrides.length ? p.overrides.map(o => (
            <Card key={o.key} edge="#0052CD" focused={o.focused}>
              <span style={sx(`font-size:10.5px;color:var(--ink-4)`)}>{o.scope}</span>
              <span style={sx(`font-size:12px;font-weight:500;color:var(--ink)`)}>{o.where}</span>
              <span style={sx(`font-size:11.5px;color:var(--ink-2);line-height:1.4`)}>{o.what}</span>
              {o.note ? <span style={sx(`font-size:11px;color:var(--ink-3)`)}>{o.note}</span> : null}
              <span style={sx(`display:flex;align-items:center;gap:8px;font-size:11px;color:var(--ink-3)`)}>
                {o.who}
                <button type="button" onClick={o.onGo} style={sx(LINK('#0052CD'))}>Go to</button>
                {o.onClear ? <button type="button" onClick={o.onClear} style={sx(LINK('#B42318'))}>Clear</button> : null}
              </span>
            </Card>
          )) : <p style={sx(`margin:4px 0;font-size:12px;color:var(--ink-3)`)}>{p.overridesEmpty}</p>
        )}
      </div>
    </aside>
  );
}
